<script lang="ts">
  import { Calendar, Clock } from 'lucide-svelte';
  
  export let title: string;
  export let excerpt: string;
  export let date: string;
  export let readTime: string;
  export let tags: string[] = [];
  export let url: string = '#';
  
  let cardElement: HTMLElement;
  let isHovering = false;
  
  function handleMouseMove(event: MouseEvent) {
    if (!cardElement) return;

    if (!isHovering) {
      isHovering = true;
    } else {
      cardElement.style.transition = 'none';
    }
    
    const rect = cardElement.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;
    
    const mouseXRelative = event.clientX - rect.left;
    const mouseYRelative = event.clientY - rect.top;
    
    const mouseX = (mouseXRelative / rect.width) * 100;
    const mouseY = (mouseYRelative / rect.height) * 100;
    
    const rotateX = (event.clientY - centerY) / 100;
    const rotateY = (centerX - event.clientX) / 100;
    
    cardElement.style.setProperty('--mouse-x', `${mouseX}%`);
    cardElement.style.setProperty('--mouse-y', `${mouseY}%`);
    cardElement.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) translateY(-4px)`;
  }
  
  function handleMouseLeave() {
    if (!cardElement) return;
    isHovering = false;
    cardElement.style.transition = 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)';
    cardElement.style.transform = 'perspective(1000px) rotateX(0deg) rotateY(0deg) translateY(0px)';
  }
  
  function handleClick(event: MouseEvent) {
    event.preventDefault();
    window.location.href = url;
    window.scrollTo(0, 0);
  }
</script>

<article
  bind:this={cardElement}
  class="glass-card blog-card"
  on:mousemove={handleMouseMove}
  on:mouseleave={handleMouseLeave}
>
  <div class="blog-content">
    <h3><a href={url} on:click={handleClick}>{title}</a></h3>
    <p class="excerpt">{excerpt}</p>
    
    <div class="blog-meta">
      <div class="meta-item">
        <Calendar size={14} />
        <span>{date}</span>
      </div>
      <div class="meta-item">
        <Clock size={14} />
        <span>{readTime}</span>
      </div>
    </div>
    
    {#if tags.length > 0}
      <div class="blog-tags">
        {#each tags as tag}
          <span class="blog-tag">{tag}</span>
        {/each}
      </div>
    {/if}
  </div>
</article>

<style>
  .blog-card {
    padding: var(--spacing-lg);
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    height: 100%;
  }
  
  .blog-content h3 {
    margin-bottom: var(--spacing-sm);
  }
  
  .blog-content h3 a {
    color: var(--text-primary);
    text-decoration: none;
    transition: color 0.3s ease;
  }
  
  .blog-content h3 a:hover {
    color: var(--accent-orange);
  }
  
  .excerpt {
    color: var(--text-secondary);
    margin-bottom: var(--spacing-md);
    line-height: 1.6;
  }
  
  .blog-meta {
    display: flex;
    gap: var(--spacing-md);
    margin-bottom: var(--spacing-md);
  }
  
  .meta-item {
    display: flex;
    align-items: center;
    gap: var(--spacing-xs);
    color: var(--text-tertiary);
    font-size: 0.875rem;
  }
  
  .blog-tags {
    display: flex;
    flex-wrap: wrap;
    gap: var(--spacing-xs);
  }
  
  .blog-tag {
    display: inline-block;
    padding: 0.25rem 0.75rem;
    background: rgba(90, 209, 151, 0.08);
    border: 1px solid rgba(90, 209, 151, 0.2);
    border-radius: 20px;
    font-size: 0.75rem;
    font-weight: 500;
    color: var(--text-secondary);
  }
</style>